module.exports = __webpack_public_path__ + "static/img/buy-system-399.5e7255e1.png";